import { COLOR } from 'src/constants/colors'

export const InputBorderHandler = (isCondition1: boolean, isCondition2: boolean): string => {
  switch (true) {
    case isCondition1:
      return `1px solid ${COLOR.brand}`
    case isCondition2:
      return `1px solid ${COLOR.red80}`
    default:
      return `1px solid ${COLOR.black20}`
  }
}

export const ColorHandler = (
  isCondition: boolean,
  option:
    | 'white_black30'
    | 'brand_black10'
    | 'brand_black30'
    | 'white_black_opacity'
    | 'brand_white',
): string => {
  switch (option) {
    case 'white_black30':
      return isCondition ? COLOR.white : COLOR.black30
    case 'brand_black10':
      return isCondition ? COLOR.brand : COLOR.black10
    case 'brand_black30':
      return isCondition ? COLOR.brand : COLOR.black30
    case 'brand_white':
      return isCondition ? COLOR.brand : COLOR.white
    case 'white_black_opacity':
      return isCondition ? COLOR.white : COLOR.blackOpacity07
    default:
      return ''
  }
}
